import styled from "styled-components";
import { Select } from "antd";

export const StyledSelect = styled(Select)`
  .ant-select-selector {
    background-color: ${(props) => (props.$isFiltered ? "rgba(136, 14, 79, 0.1) !important" : "transparent")};
  }
`;
